<template>
	<div class="min-vh-100 pb-5">
		<div class="" v-if="event">
			<p class="mb-0" v-if="event.client.contact_astreinte" ><b>Contact d'astreinte : </b>{{ event.client.contact_astreinte }}</p>
			<p class="mb-0" v-if="event.client.consignes" ><b>Consignes particulières : </b>{{ event.client.consignes }}</p>
			<div v-if="event.comment" class="font-size-h4 font-weight-bold mt-2">{{$t('Work order')}}</div>
			<p v-if="event.comment" v-html="$options.filters.nl2br(event.comment)"></p>

			<div v-for="(vehicles, type) in vehiclesDoneByType" :key="`vehicles-`+type">
				<div class="font-size-h4 font-weight-bold mt-3">{{type}}</div>
				<div class="d-block border border-success text-success text-center py-1 mb-1" 
					v-for="v in vehicles" :key="`vehicle-`+v.id">
					{{v.name}} <span v-if="v.nserie">| {{v.nserie}}</span>
				</div>
			</div>

			<div v-if="vehiclesWithMotif.length" class="font-size-h4 mt-3 font-weight-bold">{{$t('Vehicles not done')}}</div>
			<div class="d-block border border-danger text-danger text-center py-1 mb-1" 
				v-for="v in vehiclesWithMotif" :key="`vehicle-`+v.id">
				{{v.name}} <span v-if="v.nserie">| {{v.nserie}}</span>
					 <span v-if="getMotif(v)"> : {{getMotif(v)}}</span>
			</div>
			
			<a href="#" @click.prevent="showVehicles" class="btn btn-block btn-light mt-5">{{$t('Back')}}</a>
			<a href="#" @click.prevent="showInterimaire" class="btn btn-lg btn-block btn-primary">{{$t('Continue')}}</a>
		</div>

        <br>
	</div>
</template>


<script>
	
	// @ is an alias to /src
	import {mapGetters, mapActions} from 'vuex'
	
	export default {
		name: 'eventRecap',
		props: ['eventid'],
		mounted () {
			this.setPageTitle(this.event.client.name);
		},
		computed: {
			// mix the getters into computed with object spread operator
			...mapGetters('events', [
				'getEvent'
			]),
			...mapGetters('interventions', [
				'getIntervention'
			]),
			allVehicles(){
				return this.event.parcs;
			},
			vehiclesDoneByType() {
				let ids = _.map(this.intervention.parcs,(p,id)=> {
					return !p.motif && p.end_at ? id : null
				})
				return _.groupBy(_.filter(this.allVehicles, (p) => {
					return ids.indexOf(p.id) > -1
				}), 'type');
			},
			vehiclesWithMotif() {
				let ids = _.map(this.intervention.parcs,(p,id)=> {
					return p.motif ? id : null
				})
				
				return _.filter(this.allVehicles, (p) => {
					return ids.indexOf(p.id) > -1
				});
			}
		},
		beforeMount: function () {
			this.event = this.getEvent(this.eventid);
			this.intervention = this.getIntervention(this.eventid);
		},
		data: function () {
			return {
				event: {},
				intervention: {},
			}
		},
        methods: {
			...mapActions('config', ['setPageTitle']),
            showVehicles(){
			    this.$router.push({name: 'vehicles', params:{eventid: this.eventid}});
            },
            showInterimaire(){
			    this.$router.push({name: 'eventInterimaire', params:{eventid: this.eventid}});
            },
            showSignature(){
			    this.$router.push({name: 'eventSignatureClient', params:{eventid: this.eventid}});
            },
			getMotif(v){
				let response = this.intervention.parcs[v.id];
				if (!response) {
					// vehicule non vu pour le moment
					return '';
				}
				if (response.motif) {
					// vehicule qui n'a pas pu être lavé
					return response.motif;
				}
				return '';
			}
        }
	}
</script>